import axios from "axios";

export default function PurchaseorderrequestShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/purchase_order_request/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
